<template>
  <div class="account-role">
    <common-layout>
      <div slot="header">
        <h3>角色管理</h3>
      </div>
      <div slot="container">
        <div class="account-role.header">
          <el-button
            type="success"
            class="account-manage.addBtn"
            @click="openModal('')"
            >新增角色</el-button
          >
          <!-- <section>
						<el-input placeholder="请输入用户名" v-model="searchValue" class="input-with-select" clearable @change="search">
							<el-button slot="append" icon="el-icon-search" @click="search"></el-button>
						</el-input>
					</section> -->
        </div>
        <div class="account-role.table">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="headerStyle"
          >
            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="角色名" align="center">
              <template slot-scope="scope">
                <el-tag>{{ scope.row.name }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left">
              <template slot-scope="scope">
                <el-button
                  style="margin-bottom: 5px"
                  size="mini"
                  @click="openModal(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="deleteUser(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <!-- <div class="pagination">
						<div class="grid-content bg-purple-light">
							<el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true" layout="total, prev, pager, next,jumper"
							 :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
						</div>
					</div> -->
        </div>
      </div>
    </common-layout>
    <el-dialog
      title="角色管理"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <div>
        <el-row>
          <el-col :span="24">
            <div class="account-role.text">
              <i class="el-icon-box"></i> 基本信息
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2"
            ><div style="height: 40px; line-height: 40px">
              角色名称：
            </div></el-col
          >
          <el-col :span="8">
            <el-input placeholder="请填写角色名称" v-model="name"></el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 50px">
          <el-col :span="24">
            <div class="account-role.text">
              <i class="el-icon-box"></i> 权限设置
            </div>
          </el-col>
        </el-row>
        <div class="editor_content">
          <el-checkbox-group v-model="menusChecked" class="qs-p-menus">
            <div v-for="(menu, index) in permissions" :key="index">
              <el-checkbox
                :label="menu.id"
                :key="menu.id"
                class="qs-p-menu"
                @change="handleSingleMenuChange(menu)"
              >
                {{ menu.name }}
              </el-checkbox>
              <el-checkbox-group v-model="submenusChecked" class="qs-submenus">
                <div
                  v-for="(submenu, subIndex) in menu.children"
                  :key="subIndex"
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  "
                >
                  <el-checkbox
                    :label="submenu.id"
                    :key="submenu.id"
                    class="qs-p-submenu"
                    @change="handleSingleSubmenuChange(submenu, menu)"
                  >
                    {{ submenu.name }}
                  </el-checkbox>
                  <!-- 	<el-switch v-model="submenu.child_mode == 1" active-text="可写" inactive-text="可读" active-color="#7945A8" 
									 @change="switchEvent(index,subIndex)">
									</el-switch> -->
                </div>
              </el-checkbox-group>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createdRoleUser">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import urlConfig from "../../url";
import validate from "../../../utils/W.validate.js";
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      rowId: "",
      searchValue: "",
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      total: 20,
      current_page: 1,
      per_page: 10,
      tableData: [],
      formLabelWidth: "100px",
      dialogFormVisible: false,
      name: "",
      menusChecked: [],
      submenusChecked: [],
      checkAll: false,
      permissions: [],
      submitMenus: [],
      loadedRoleMenus: [],
    };
  },
  methods: {
    getRoleMenus(data) {
      if (!data) {
        return [];
      }
      let menus = data.menuIds || data.menu_ids || [];
      if (typeof menus === "string") {
        try {
          menus = JSON.parse(menus);
        } catch (e) {
          menus = [];
        }
      }
      return Array.isArray(menus) ? menus : [];
    },
    // 菜单
    handleSingleMenuChange(menu) {
      console.log(menu);
      let status = this.menusChecked.indexOf(menu.id) !== -1;
      if (status) {
        this.submenusChecked = this.submenusChecked.concat(
          (menu.children || []).map((item) => item.id)
        );
      } else {
        (menu.children || []).forEach((item) => {
          let index = this.submenusChecked.indexOf(item.id);
          if (index !== -1) {
            this.submenusChecked.splice(index, 1);
          }
        });
      }
      this.formatMeuns(this.menusChecked, this.submenusChecked, "父菜单");
    },
    // 页面
    handleSingleSubmenuChange(submenu, menu) {
      let status = this.submenusChecked.indexOf(submenu.id) !== -1;
      if (status) {
        if (menu) {
          this.menusChecked = Array.from(
            new Set(this.menusChecked).add(menu.id)
          );
        }
      } else {
        if (menu) {
          let submenuIds = (menu.children || []).map((item) => item.id);
          let empty = true;
          for (let subId of submenuIds) {
            if (this.submenusChecked.indexOf(subId) !== -1) {
              empty = false;
            }
          }
          if (empty) {
            let menusChecked = new Set(this.menusChecked);
            menusChecked.delete(menu.id);
            this.menusChecked = Array.from(menusChecked);
          }
        }
      }
      this.formatMeuns(this.menusChecked, this.submenusChecked, "子菜单");
    },
    // 提交格式化菜单
    formatMeuns(parentIdArr, childIdArr, type) {
      let result = [];
      this.permissions.map((item, index) => {
        parentIdArr.map((subItem) => {
          if (item.id == subItem) {
            result.push({
              children: type == "父菜单" ? item.children || [] : [],
              icon: item.icon,
              id: item.id,
              intro: item.intro,
              name: item.name,
              pid: item.pid,
              sort: item.sort,
              url: item.url,
              label: item.label,
            });
            if (type == "子菜单") {
              (item.children || []).map((childItem) => {
                let aa = childIdArr.some((f) => f == childItem.id);
                if (aa) {
                  result.map((reItem, reIndex) => {
                    if (reItem.id == item.id) {
                      result[reIndex].children.push(childItem);
                    }
                  });
                }
              });
            }
          }
        });
      });
      this.submitMenus = result;
    },
    //展示已选择格式化菜单
    formatShowMeubs(data) {
      let parentIdArrs = [];
      let childIdArrs = [];
      data = Array.isArray(data) ? data : [];
      data.map((item) => {
        parentIdArrs.push(item.id);
        item.children?.map((subItem) => {
          childIdArrs.push(subItem.id);
          this.permissions.map((pItem, pIndex) => {
            if (pItem.id == item.id) {
              pItem.children?.map((cItem, cIndex) => {
                if (cItem.id == subItem.id) {
                  this.permissions[pIndex].children[cIndex].child_mode =
                    subItem.child_mode;
                }
              });
            }
          });
        });
      });

      this.menusChecked = parentIdArrs;
      this.submenusChecked = childIdArrs;
      this.submitMenus = data;
    },
    switchEvent(pIndex, cIndex) {
      this.permissions[pIndex].children[cIndex].child_mode =
        this.permissions[pIndex].children[cIndex].child_mode == 0 ? 1 : 0;
    },
    //打开新增/编辑角色
    openModal(row) {
      this.resetForm();
      this.dialogFormVisible = true;
      let that = this;
      const menuPromise = this.getAllMenu();
      if (row) {
        this.rowId = row.id;
        menuPromise.then(() => {
          that.http.get(`${urlConfig.devUrl}apij2/admin-api/system/admin-role/get?id=` + row.id).then((res) => {
            if (res.code == 0) {
              const roleMenus = this.getRoleMenus(res.data);
              that.name = res.data.name;
              this.loadedRoleMenus = roleMenus;
              this.formatShowMeubs(roleMenus);
            }
          });
        });
      } else {
        menuPromise;
      }
    },
    //创建角色
    createdRoleUser() {
      if (validate.validateEmpty(this.name)) {
        this.$message.error("请填写角色名称");
        return;
      }
      if (this.menusChecked.length == 0) {
        this.$message.error("请选择权限");
        return;
      }
      this.formatMeuns(this.menusChecked, this.submenusChecked, "子菜单");
      if (this.rowId && this.loadedRoleMenus.length > 0 && this.submitMenus.length == 0) {
        this.$message.error("权限数据未加载完成，请重新打开后再保存");
        return;
      }
      if (this.rowId) {
        this.toEdit();
      } else {
        this.toAdd();
      }
    },
    toAdd() {
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/system/admin-role/create`, { name: this.name, menuIds: this.submitMenus })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.dialogFormVisible = false;
            this.getData("/Role");
          }
        });
    },
    toEdit() {
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/system/admin-role/update`, {
          id: this.rowId,
          name: this.name,
          menuIds: this.submitMenus,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.dialogFormVisible = false;
            this.getData("/Role");
            this.$store.dispatch("setRole", !this.$store.getters.isRole);
          }
        });
    },
    search() {},
    deleteUser(row) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.toDelete(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    toDelete(id) {
      this.http.request(`${urlConfig.devUrl}apij2/admin-api/system/admin-role/delete?id=` + id, "", "delete").then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getData("/Role");
        }
      });
    },
    resetForm() {
      this.name = "";
      this.menusChecked = [];
      this.submenusChecked = [];
      this.submitMenus = [];
      this.loadedRoleMenus = [];
    },
    getData(url) {
      let params = {
        page: 1,
        pageSize: 100
      };

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/admin-role/page`, params)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.data;
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    getAllMenu() {
      return this.http
        .get(`${urlConfig.devUrl}apij2/admin-api/system/menu/listTree`)
        .then((res) => {
          if (res.code == 0) {
            this.permissions = res.data;
            console.log(this.permissions, 456);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
  },
  mounted() {
    this.getData("/Role");
    this.getAllMenu();
  },
};
</script>
<style lang="scss">
@include component(account-role) {
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  @include part(addBtn) {
    margin-right: 30px !important;
    background: #623aa2 !important;
    color: #fff;
    border: none;
    outline: none;
  }

  @include part(table) {
    margin-top: 30px;
  }

  @include part(text) {
    width: 100%;
    text-align: left;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 10px;
    color: #7945a8;
    font-size: 16px;
    font-weight: bold;
  }

  @include component(el-row) {
    margin-bottom: 20px;
  }

  .el-form-item__label {
    text-align: left;
  }
  .editor_content {
    width: 100%;
    padding: 0 24px 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .qs-all {
    background-color: #f2f6fc;
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 10px;
    text-align: left;
  }
  .qs-p-menus {
    width: 100%;
    & > div {
      background-color: #f2f6fc;
      padding: 20px 20px 0;
      box-sizing: border-box;
      margin-bottom: 10px;
      text-align: left;

      & .qs-submenus {
        padding: 10px 0 10px 60px;

        & .qs-p-submenu {
          min-width: 120px;
          // margin-bottom: 20px;
        }

        & .qs-elements {
          display: inline-block;
          margin-left: 30px;
          padding-left: 20px;
          margin-bottom: 20px;
          box-sizing: border-box;
          border-left: solid 1px #ccc;
        }
      }
    }
  }
}
</style>
